import { sendGAEvent } from '@next/third-parties/google';
import { reportEvent } from '@/app/utils';
import { useGlobalModal } from './use-global-modal';

export const useUpgradeDialogs = () => {
  const { open: openPlanDetailDialog } = useGlobalModal('planDetailDialog');

  const handleOpenPlanDialog = (from_page?: string) => {
    openPlanDetailDialog({ fromPage: from_page });

    if (from_page) {
      reportEvent('vip_price_modal_exposure', {
        from_page,
      });
      sendGAEvent('event', 'subscription_exposure', {
        from_page,
      });
    }
  };

  return {
    handleOpenPlanDialog,
  };
};
